import PatientInvoiceDialog from './PatientInvoiceDialog';

export default PatientInvoiceDialog;
